import { isAPIError } from '@user/store/services/crud'
import {
  leadTypeImportOptionAssignment,
  leadTypeOptionsLeadAssignment,
  leadTypeServiceBotOptionAssignment,
} from '@user/components/Leads/LeadFilters/typings'

import {
  COVERAGE_ERROR_PREFIX,
  getDeleteDisableCoverageBody,
  getEditCoverageBody,
} from '../constants'

const LEAD_TYPE_LABELS = new Map(
  [
    ...leadTypeOptionsLeadAssignment,
    ...leadTypeServiceBotOptionAssignment,
    ...leadTypeImportOptionAssignment,
  ].map(({ id, label }) => [id, label]),
)

/**
 * Reads a rejected assignment-rule response and, when it is the server's
 * auto-review coverage error, returns the affected lead types as display
 * labels (`ServiceBot` becomes `Service Bot`; unknown names stay as-is).
 * Returns `null` for any other payload, including `undefined`.
 */
export function parseCoverageError(payload: unknown): string[] | null {
  if (typeof payload !== 'object' || payload === null) {
    return null
  }
  if (
    !isAPIError(payload) ||
    !payload.Message.startsWith(COVERAGE_ERROR_PREFIX)
  ) {
    return null
  }

  return payload.Message.slice(COVERAGE_ERROR_PREFIX.length)
    .split(', ')
    .map((name) => LEAD_TYPE_LABELS.get(name) ?? name)
}

/** Message for the "Cannot delete or disable" modal, given display labels. */
export function getDeleteDisableCoverageMessage(labels: string[]): string {
  return getDeleteDisableCoverageBody(labels.join(', '))
}

/** Message for the "Cannot remove Type" modal, given display labels. */
export function getEditCoverageMessage(labels: string[]): string {
  return getEditCoverageBody(labels.join(', '))
}
